import React from "react";
import CardClass from "../../../CardClass";
import EmptyState from "../../../EmptyState";
import MUIButton from "@mui/material/Button";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import MUISwitch from "@mui/material/Switch";
import MUIIconButton from "@mui/material/IconButton";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUIGrid from "@mui/material/Grid";
import DialogSearchTerm from "../../../Dialog/Search/DialogSearchTerm";
import TileTerm from "../../../Tile/TileTerm";
import Term from "../../../../Utility/Crud/Term";
import MainContext from "../../../../Context/MainContext/MainContext";

export default class CardAdminQueueFilterBrightreeStopHoldReasonTerm extends CardClass {
  static contextType = MainContext; // For legacy class components

  constructor(props) {
    super(props);

    this.state.termDialogOpen = false;
  }

  /**
   * Render the content of the card.
   */
  renderContent() {
    const handleRemove = (termId) => {
      const filter = this.props.queue.filter;
      if (
        !filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"]
          ?.properties?.value
      ) {
        return;
      }
      filter[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ].properties.value = filter[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ].properties.value.filter((entry) => entry !== termId);
      if (
        filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"]
          .properties.value.length === 0
      ) {
        delete filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"];
      }

      this.props.onChange({
        filter: filter,
      });
    };

    const values =
      this.props.queue?.filter?.[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ]?.properties?.value || [];

    const excludeChecked =
      this.props.queue?.filter?.[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ]?.properties?.operator === "not in";

    const handleExcludeToggle = (event) => {
      const filter = this.props.queue.filter;
      filter[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ].properties.operator = event.target.checked ? "not in" : "in";

      this.props.onChange({
        filter: filter,
      });
    };

    if (values.length > 0) {
      return (
        <>
          <MUIFormControlLabel
            sx={{ marginLeft: 0 }}
            control={
              <MUISwitch
                color="error"
                checked={excludeChecked}
                onChange={handleExcludeToggle}
              />
            }
            label="Exclude"
          />
          <MUIGrid container spacing={2}>
            {values.map((termId) => {
              return (
                <MUIGrid key={termId} item xs={12} sm={6} md={4}>
                  <TileTerm
                    term={this.context.termsIndexed[termId]}
                    iconButtons={[
                      <MUIIconButton onClick={() => handleRemove(termId)}>
                        <MUIDeleteIcon />
                      </MUIIconButton>,
                    ]}
                  />
                </MUIGrid>
              );
            })}
            {this.renderDialog()}
          </MUIGrid>
        </>
      );
    } else {
      return (
        <>
          <EmptyState line1="Not Configured" line2="Showing all Terms" />
          {this.renderDialog()}
        </>
      );
    }
  }

  /**
   * Renders a search dialog of Terms
   */
  renderDialog() {
    const handleAdd = (term) => {
      const filter = (this.props.queue && this.props.queue.filter) || {};
      if (!filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"]) {
        filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"] = {
          type: "set",
          properties: {
            operator: "in",
            value: [],
          },
        };
      }
      filter[
        "brightree_stop_hold.brightree_stop_hold_reason_term_id"
      ].properties.value = [
        ...new Set([
          ...(filter["brightree_stop_hold.brightree_stop_hold_reason_term_id"]
            .properties.value || []),
          term.id,
        ]),
      ];

      this.props.onChange({
        filter: filter,
      });
    };

    return (
      <DialogSearchTerm
        open={this.state.termDialogOpen}
        onClose={() => this.setState({ termDialogOpen: false })}
        onSelect={handleAdd}
        data={Term.read(this.context.termsIndexed, [
          { key: "type", value: "brightree_stop_hold_reason" },
        ])}
      />
    );
  }

  /**
   * Renders add Term button
   */
  getActions() {
    const handleAdd = () => {
      this.setState({
        termDialogOpen: true,
      });
    };

    const buttonItems = [
      <MUIButton
        component="label"
        variant="outlined"
        startIcon={<MUIAddIcon />}
        onClick={handleAdd}
      >
        Add Brightree Stop Hold Reason
      </MUIButton>,
    ];

    return buttonItems;
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "Filter: Brightree Stop Hold > Reason";
  }
}
